var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLivoritLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 135,
    height: 40,
    viewBox: "0 0 135 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M50.5326 26.9069H57.8193V31.3166H46.6834C46.426 31.3166 46.1792 31.2146 45.9972 31.033C45.8151 30.8514 45.7129 30.6051 45.7129 30.3483V8.68134H49.562C49.8194 8.68134 50.0663 8.78336 50.2483 8.96495C50.4303 9.14654 50.5326 9.39284 50.5326 9.64965V26.9069Z",
    fill: "#FEFEFE"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M60.2379 31.3166V14.2046H64.9022V31.3166H60.2379Z",
    fill: "#FEFEFE"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M80.687 14.2065H84.903L77.8569 31.3166H73.835C71.5148 25.6126 69.1933 19.9093 66.8705 14.2065H71.0535C71.2557 14.2059 71.453 14.2682 71.618 14.3849C71.7829 14.5015 71.9072 14.6667 71.9736 14.8572L75.8557 25.9076L79.7611 14.8572C79.8277 14.6657 79.9529 14.4999 80.1191 14.3832C80.2852 14.2664 80.4838 14.2046 80.687 14.2065Z",
    fill: "#FEFEFE"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M93.6261 31.6497C92.0044 31.6812 90.399 31.3218 88.9462 30.602C87.5952 29.9138 86.4783 28.8425 85.7357 27.5228C84.9593 26.1684 84.5711 24.5759 84.5711 22.7451C84.5711 20.0041 85.407 17.8403 87.0789 16.2535C88.7508 14.6668 90.9332 13.8734 93.6261 13.8734C96.3281 13.8734 98.5157 14.6668 100.189 16.2535C101.862 17.8403 102.699 20.0041 102.699 22.7451C102.699 25.4977 101.862 27.6699 100.189 29.2619C98.5157 30.8538 96.3281 31.6497 93.6261 31.6497ZM93.5776 27.8384C94.9286 27.8384 96.0195 27.3724 96.8502 26.4402C97.681 25.508 98.0971 24.2763 98.0983 22.7451C98.0983 21.2126 97.6823 19.9809 96.8502 19.05C96.0182 18.1192 94.9273 17.6531 93.5776 17.6518C92.9763 17.6344 92.3788 17.7517 91.8289 17.995C91.279 18.2383 90.7908 18.6015 90.4001 19.0578C89.5809 19.9977 89.1714 21.2242 89.1714 22.7374C89.1714 24.2505 89.5809 25.477 90.4001 26.417C90.7893 26.8761 91.2769 27.2422 91.8268 27.4882C92.3768 27.7342 92.9751 27.8539 93.5776 27.8384Z",
    fill: "#FEFEFE"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M109.166 17.1192C109.605 16.32 110.329 15.6345 111.338 15.0625C112.321 14.498 113.436 14.2027 114.57 14.2065V18.4845C112.748 18.4845 111.43 18.8286 110.614 19.5168C109.799 20.2049 109.391 21.425 109.391 23.177V31.3108H104.733V14.2065H108.196C108.453 14.2065 108.7 14.3086 108.882 14.4901C109.064 14.6717 109.166 14.918 109.166 15.1748V17.1192Z",
    fill: "#FEFEFE"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M116.775 31.3166V14.2046H121.44V31.3166H116.775Z",
    fill: "#FEFEFE"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M131.943 31.3166C130.336 31.3166 129.092 30.8538 128.212 29.9281C127.332 29.0024 126.892 27.6842 126.892 25.9735V17.8861H123.643V14.2065H125.456C125.971 14.203 126.465 13.9962 126.828 13.6313C127.192 13.2663 127.396 12.7728 127.397 12.2583V8.68134H131.58V14.2065H134.99V17.8861H131.589V25.4583C131.589 26.934 132.227 27.6719 133.503 27.6719H135V31.3166H131.943Z",
    fill: "#FEFEFE"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M60.2379 7.51355H63.9259C64.1833 7.51355 64.4302 7.61557 64.6122 7.79716C64.7942 7.97876 64.8964 8.22505 64.8964 8.48186V12.1615H61.2084C60.951 12.1615 60.7042 12.0594 60.5221 11.8778C60.3401 11.6962 60.2379 11.45 60.2379 11.1931V7.51355Z",
    fill: "#FEFEFE"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M116.775 7.51355H120.463C120.721 7.51355 120.968 7.61557 121.15 7.79716C121.332 7.97876 121.434 8.22505 121.434 8.48186V12.1615H117.746C117.488 12.1615 117.242 12.0594 117.06 11.8778C116.878 11.6962 116.775 11.45 116.775 11.1931V7.51355Z",
    fill: "#FEFEFE"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.0351 32.0796L0.0112225 23.4268V13.0813C-0.00654796 11.8761 0.302887 10.6885 0.906726 9.64455C1.51056 8.60056 2.3863 7.73905 3.44108 7.15136L14.841 0.584259C15.8778 -0.0316767 17.0621 -0.356812 18.2689 -0.356812C19.4756 -0.356812 20.6599 -0.0316767 21.6968 0.584259L22.1704 0.857324L8.08799 8.96791C7.35627 9.39289 6.82297 10.0897 6.60473 10.9058C6.38648 11.722 6.50104 12.5912 6.92335 13.3234L16.7781 30.3521C16.9173 30.5935 16.9729 30.8739 16.9362 31.15C16.8996 31.426 16.7728 31.6824 16.5754 31.8793C16.378 32.0762 16.1211 32.2027 15.8444 32.2393C15.5678 32.2758 15.2867 32.2204 15.0448 32.0815L15.0351 32.0796Z",
    fill: "url(#paint0_linear_10_1764)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30.6694 33.5232L21.6939 38.6998C20.6562 39.3172 19.4704 39.6431 18.2621 39.6431C17.0539 39.6431 15.8681 39.3172 14.8303 38.6998L3.43045 32.1346C2.37711 31.5472 1.50237 30.6869 0.898647 29.6444C0.294924 28.602 -0.0153595 27.4162 0.000584944 26.2124V25.6663L14.0811 33.7807C14.815 34.2016 15.686 34.3156 16.504 34.0979C17.3219 33.8802 18.0202 33.3484 18.4465 32.6188L28.3013 15.5765C28.4412 15.3354 28.6568 15.147 28.9149 15.0406C29.1729 14.9341 29.4589 14.9155 29.7286 14.9876C29.9983 15.0598 30.2366 15.2186 30.4067 15.4395C30.5768 15.6604 30.6691 15.9312 30.6694 16.2097V33.5232Z",
    fill: "url(#paint1_linear_10_1764)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.07901 10.6378L24.1028 1.98303L33.0861 7.14995C34.1407 7.73803 35.0163 8.59957 35.6204 9.64342C36.2246 10.6873 36.5346 11.8746 36.5179 13.0799V26.2122C36.5349 27.4163 36.2256 28.6026 35.6225 29.6457C35.0194 30.6888 34.1451 31.55 33.0919 32.1382L32.6183 32.4113V16.1882C32.6168 15.3432 32.2796 14.5333 31.6808 13.9358C31.082 13.3384 30.2702 13.002 29.4233 13.0005H9.71374C9.43452 13.0002 9.16319 12.9081 8.94175 12.7384C8.72031 12.5687 8.56113 12.3309 8.48884 12.0618C8.41655 11.7928 8.4352 11.5074 8.54189 11.25C8.64858 10.9925 8.83736 10.7774 9.07901 10.6378Z",
    fill: "url(#paint2_linear_10_1764)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_10_1764",
    x1: 5.41515,
    y1: 26.5389,
    x2: 20.697,
    y2: 0.00976764,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#1460DE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#1C8AE9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_10_1764",
    x1: 30.6694,
    y1: 27.295,
    x2: 0.000584961,
    y2: 27.295,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#0047BB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#1460DE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_10_1764",
    x1: 18.6989,
    y1: 5.09713,
    x2: 33.9807,
    y2: 31.6263,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#1C8AE9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#0047BB"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLivoritLogo);
export default __webpack_public_path__ + "static/media/livorit-logo.29d54df15e148ef0078fab1576a9b987.svg";
export { ForwardRef as ReactComponent };